module.exports = __webpack_public_path__ + "00555a1a92e4cff9bb4b630791007cff.png";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Spotin_TM_Logo_Off-White_Small_RGB.png
// module id = 291
// module chunks = 0